import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import { colors } from '../../shared/colors'
const styles = {
  root: {
    position: 'absolute',
    left: '50%',
    margin: '-40px 0px 0px -40px',
    zIndex: 3000,
    top: '50%'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1000,
    backgroundColor: colors.magellan5Black,
    opacity: '.7'
  }
}
function LoadingSpinner (props) {
  const {size='8rem', thickness} = props
  return (
    <div>
      <div className={props.classes.backdrop} />
      <div className={props.classes.root}>
        <CircularProgress size={size} thickness={thickness} color='primary' />
      </div>
    </div>
  )
}

LoadingSpinner.propTypes = {
  size: PropTypes.number,
  thickness: PropTypes.number,
  classes: PropTypes.object
}

export default withStyles(styles)(LoadingSpinner)
